import React from "react";

import { usePlannerTaskPanelState } from "../hooks/usePlannerTaskPanelState";
import MyPlannerHeading from "./MyPlannerHeading";
import MyPlannerList from "./List/MyPlannerList";

function MyPlannerTasks({ filter, setFilter, filteredTasks }) {
  const {
    anchorEl,
    handleClose,
    handleOpen,
    inputValue,
    setInputValue,
    visibleTasks,
  } = usePlannerTaskPanelState(filteredTasks);

  return (
    <div>
      <MyPlannerHeading inputValue={inputValue} setInputValue={setInputValue} />
      <MyPlannerList
        filter={filter}
        filteredTasks={visibleTasks}
        anchorEl={anchorEl}
        setFilter={setFilter}
        handleOpen={handleOpen}
        handleClose={handleClose}
        inputValue={inputValue}
      />
    </div>
  );
}

export default MyPlannerTasks;
